<template>
  <div class="messageNotification">
    <el-form
      :inline="true"
      ref="formRef"
      :model="tableParams"
      class="demo-form-inline"
    >
      <el-form-item label="消息类型" prop="">
        <el-input v-model="tableParams.sex1" placeholder="消息类型"> </el-input>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="tableParams.sex2" placeholder="标题"> </el-input>
      </el-form-item>
      <el-form-item label="内容">
        <el-input v-model="tableParams.sex3" placeholder="内容"> </el-input>
      </el-form-item>
      <el-form-item label="接收时间">
        <el-date-picker
          v-model="tableParams.sex4"
          type="date"
          placeholder="接收时间"
        />
      </el-form-item>
      <el-form-item label="发送人">
        <el-input v-model="tableParams.sex5" placeholder="发送人"> </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetForm(formRef)">重置</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-button type="danger">删除</el-button>
      <!-- <el-button type="primary" size="small">标记为已读</el-button>
      <el-button type="primary" size="small">标记未已读</el-button> -->
    </div>
    <h-table
      ref="tableRef"
      v-model:data="tableData"
      v-model:columns="columns"
      :method="notifymessageunread_message"
      :params="tableParams"
      @handleClick="handleClick"
      @select="hzTableSelect"
      style="height: 93%"
    >
      <template #operation="{}">
        <el-button type="danger" @click="aclick" size="small">删除</el-button>
        <!-- <el-button type="primary" size="small">标记已读</el-button> -->
      </template>
      <template #messageText="{ row }">
        <span v-html="row.messageText"></span>
      </template>
      <template #sendTime="{ row }">
        {{ formatDateHMS(row.sendTime) }}
      </template>
      <template #status="{ row }">
        {{ row.status == "1" ? "已读" : "未读" }}
      </template>
    </h-table>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import { notifymessageunread_message } from "@/api/messageCenter/messageCenterApi.js";
import { formatDateHMS } from "@/utils/index.js";
export default defineComponent({
  setup() {
    const tableRef = ref(null);
    const formRef = ref(null);
    const state = reactive({
      tableData: [],
      tableParams: {},
      columns: [
        { type: "selection" },
        // {
        //   label: "消息类型",
        //   prop: "name"
        // },
        {
          label: "标题",
          prop: "messageTitle",
        },
        {
          label: "内容",
          slot: "messageText",
        },
        {
          label: "接收时间",
          slot: "sendTime",
        },
        {
          label: "发送人",
          prop: "creater",
        },
        {
          label: "状态",
          slot: "status",
        },
        {
          label: "操作",
          slot: "operation",
        },
      ],
    });
    const methods = {
      hzTableSelect() {},
      onSubmit() {
        tableRef.value && tableRef.value.refresh();
      },
      resetForm(formEl) {
        if (!formEl) return;
        formEl.resetFields();
      },
    };
    return {
      ...toRefs(state),
      ...methods,
      tableRef,
      formRef,
      notifymessageunread_message,
      formatDateHMS,
    };
  },
});
</script>
<style lang="scss" scoped>
.messageNotification {
  padding: 20px;
}
</style>
